import { useMutation } from '@tanstack/react-query'

import * as api from '../api'
import useInvalidate from '../useInvalidate'

export default function useDeleteNotifications() {
  const invalidate = useInvalidate()

  return useMutation({
    mutationFn: async ({ notificationUuids }: { notificationUuids: string[] }) => {
      await api.del(`notification`, notificationUuids)
      await invalidate.notifications()
      await invalidate.notificationCount()
    },
  })
}
